import { render, staticRenderFns } from "./ResumeTippy.vue?vue&type=template&id=74e33c84&scoped=true"
import script from "./ResumeTippy.vue?vue&type=script&lang=js"
export * from "./ResumeTippy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e33c84",
  null
  
)

export default component.exports